const dsValidate = (($) => {

    const hasStorage = typeof(Storage) !== "undefined";

    function checkLength(arr, obj, ln = 0) {
        arr.forEach(function (props) {
            if (typeof props === 'string') { props = [props, 'input']; }
            const el = props[1] + '#' + props[0];
            return obj[props[0]].length > ln ? $(el).removeClass('mandatory') : $(el).addClass('mandatory');
        });
    }

    function checkChecked(arr) {
        arr.forEach(function (name) {
            const el = 'input#' + name;
            return $(el).is(':checked') ? $(el).removeClass('mandatory') : $(el).addClass('mandatory');
        });
    }

    function validEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    function validMobile(mobile) {
        const re = /^04[0-9]{8}$/;
        return re.test(mobile);
    }

    function validPostcodeData(address) {
        return $.ajax({
            url: dsUtilities.urlAddress() + '/validate_postcode_data',
            type: 'post',
            data: { address },
            dataType: 'json'
        });
    }

    function reCAPTCHAVerify() {
        return $.ajax({
            url: 'index.php?route=common/header/recaptcha',
            type: 'post',
            dataType: 'json',
            data: { response: grecaptcha.getResponse() }
        });
    }

    function login() {
        if (hasStorage) {
            localStorage.setItem('logged_in', true);
        }
    }

    function logout() {
        if (hasStorage) {
            localStorage.removeItem('logged_in');
        }
    }

    function loggedIn() {
        return !hasStorage || hasStorage && localStorage.getItem('logged_in') !== null;
    }

    function make_payment() {
        if (hasStorage) {
            localStorage.setItem('make_payment', true);
        }
        return $.Deferred().resolve();
    }

    function made_payment() {
        if (hasStorage) {
            localStorage.removeItem('make_payment');
        }
    }

    function payment_made() {
        return !hasStorage || hasStorage && localStorage.getItem('make_payment') === null;
    }

    $(document).ready(function () {

        $('button#create-account').on('click', function () {
            reCAPTCHAVerify().done(function (response) {
                if (response.verify.success) {
                    $('form#form_register').submit();
                }
            });
        });

    });

    return {
        checkLength       : checkLength,
        checkChecked      : checkChecked,
        validEmail        : validEmail,
        validMobile       : validMobile,
        validPostcodeData : validPostcodeData,
        reCAPTCHAVerify   : reCAPTCHAVerify,
        login             : login,
        logout            : logout,
        loggedIn          : loggedIn,
        make_payment      : make_payment,
        made_payment      : made_payment,
        payment_made      : payment_made
    }

})(jQuery);